//components
export { default as IAIUseForm } from "./components/IAIUseForm/IAIUseForm";
export { default as IAIButton } from "./components/IAIButton/IAIButton.vue";
export { default as IAIBrowseFiles } from "./components/IAIBrowseFiles/IAIBrowseFiles.vue";
export { default as IAICard } from "./components/IAICard/IAICard.vue";
export { default as IAICarousel } from "./components/IAICarousel/IAICarousel.vue";
export { default as IAICheckbox } from "./components/IAICheckbox/IAICheckbox.vue";
export { default as IAIDataSize, sizeDisplay } from "./components/IAIDataSize/IAIDataSize.vue";
export { default as IAIDragDropCard } from "./components/IAIDragDropCard/IAIDragDropCard.vue";
export { default as IAIExpand } from "./components/IAIExpand/IAIExpand.vue";
export { default as IAIExpandCard } from "./components/IAIExpandCard/IAIExpandCard.vue";
export { default as IAIExpandQuestion } from "./components/IAIExpandQuestion/IAIExpandQuestion.vue";
export { default as IAIFadeAnimation } from "./components/IAIFadeAnimation/IAIFadeAnimation.vue";
export { default as IAIInfoBox } from "./components/IAIInfoBox/IAIInfoBox.vue";
export { default as IAIInitialsGraphic } from "./components/IAIInitialsGraphic/IAIInitialsGraphic.vue";
export { default as IAIInputText } from "./components/IAIInputText/IAIInputText.vue";
export { default as IAILink } from "./components/IAILink/IAILink.vue";
export { default as IAILoader } from "./components/IAILoader/IAILoader.vue";
export type { Color as LoaderColor } from "./components/IAILoader/IAILoader.vue";
export { default as IAIModal } from "./components/IAIModal/IAIModal.vue";
export { default as IAIStepper, type Step } from "./components/IAIStepper/IAIStepper.vue";
export { default as IAITab, type Tab } from "./components/IAITab/IAITab.vue";

export type { MultiOption } from "./components/IAISelect/IAIMultiSelectWrapper.vue";
export { default as IAIProgress } from "./components/IAIProgress/IAIProgress.vue";
export { default as IAIScrollableContainer } from "./components/IAIScrollableContainer/IAIScrollableContainer.vue";
export { default as IAISeparator } from "./components/IAISeparator/IAISeparator.vue";
export { default as IAISlider } from "./components/IAISlider/IAISlider.vue";
export { default as IAISpinner } from "./components/IAISpinner/IAISpinner.vue";
export { default as IAITag } from "./components/IAITag/IAITag.vue";
export { default as IAITextArea } from "./components/IAITextArea/IAITextArea.vue";
export { default as IAITooltip } from "./components/IAITooltip/IAITooltip.vue";
export { default as Icons } from "./components/IAIIcon/icons";
export { default as BasePackageCard } from "./components/BasePackageCard/BasePackageCard.vue";
export { iconsVue as IconsVue } from "./components/IAIIcon/icons";
export { default as IAICombobox } from "./components/IAICombobox/IAICombobox.vue";
export type { Option as ComboboxOption } from "./components/IAICombobox/IAICombobox.vue";

// IAIContextMenu
export { default as IAIContextMenu } from "./components/IAIContextMenu/IAIContextMenu.vue";
export { default as IAIContextMenuItem } from "./components/IAIContextMenu/IAIContextMenuItem.vue";
export { default as IAIContextMenuItemContent } from "./components/IAIContextMenu/IAIContextMenuItemContent.vue";

//organisms
export { default as OTPInput } from "./organisms/OTPInput/OTPInput.vue";
export { default as SocialLinks } from "./organisms/SocialLinks/SocialLinks.vue";
export type { ISocialLinks as ISocialLinks } from "./organisms/SocialLinks/SocialLinks.vue";

export { default as ReadMore } from "./organisms/ReadMore.vue";

import IAISelectWrapper from "./components/IAISelect/IAISelectWrapper.vue";
import IAISelectGroup from "./components/IAISelect/IAISelectGroup.vue";
import IAISelectItem from "./components/IAISelect/IAISelectItem.vue";
import IAIMultiSelectWrapper from "./components/IAISelect/IAIMultiSelectWrapper.vue";

const IAISelect = {
  Wrapper: IAISelectWrapper,
  Group: IAISelectGroup,
  Item: IAISelectItem,
  MultiWrapper: IAIMultiSelectWrapper,
};

export { IAISelect };

export { default as IAISwitch } from "./components/IAISwitch/IAISwitch.vue";

export { default as IAIRadioGroup } from "./components/IAIRadioGroup/IAIRadioGroup.vue";
export { default as IAIRadioGroupItem } from "./components/IAIRadioGroup/IAIRadioGroupItem.vue";

export { default as IAISkeleton } from "./components/IAISkeleton.vue";
